import * as types from './actionTypes';
// import api from 'api/mock';
import api from '../../../api/';

export function getData(eateryname, cityname) {
  // body...
  return async (dispatch, getState) => {
    dispatch({
      type: types.LOADING,
    });
    try {
      const cities = await api.getCities();
      const eatery = await api.getEatery(eateryname);
      const related = await api.getRelatedEateries(eatery.data.entity.id);
      const featured = await api.getFeaturedEatery(cityname, 'EATERY');
      dispatch({
        type: types.LOADED,
        cities,
        eatery: eatery.data,
        related,
        featured,
      });
    } catch (error) {
      console.log(error);
    }
  };
}
